import { useEffect, useRef, useState } from "react";

// Photoreal hero loop (Higgsfield-rendered, the app's RIPP Core at its heart) — one film per engine, crossfading on switch —
// with a per-stage light grade and a pulse on every stage change.
const GRADE = { discovery: "56,189,248", candidate: "167,139,250", hive: "192,132,252", verify: "52,211,153", purchase: "251,146,60", monitor: "56,189,248", exit: "245,196,81" };
const film = (engine) => `/cinema/core_hero${engine && engine !== "memes" ? `_${engine}` : ""}`;

export function HeroFilm({ engine, stage, reduced }) {
  const v = useRef(null);
  const [pulse, setPulse] = useState(0);
  useEffect(() => { setPulse((n) => n + 1); }, [stage, engine]);
  useEffect(() => { if (v.current) v.current.playbackRate = reduced ? 0.6 : 1; }, [reduced, engine]);
  const rgb = GRADE[stage] || GRADE.discovery, src = film(engine);
  return (
    <div className="cine-film" data-testid="cinema-hero-film">
      <video key={src} ref={v} className={`cine-film-video ${reduced ? "" : "is-in"}`} autoPlay muted loop playsInline preload="auto" poster={`${src}_poster.jpg`} data-testid="cinema-hero-video">
        <source src={`${src}.webm`} type="video/webm" />
        <source src={`${src}.mp4`} type="video/mp4" />
      </video>
      <div className="cine-film-grade" style={{ background: `radial-gradient(60% 55% at 50% 46%, rgba(${rgb},0.22), rgba(${rgb},0.06) 45%, transparent 70%)` }} />
      {!reduced && <div key={pulse} className="cine-film-pulse" style={{ background: `radial-gradient(28% 30% at 50% 45%, rgba(${rgb},0.55), transparent 70%)` }} />}
      <div className="cine-film-vignette" />
      <div className="cine-film-grain" />
    </div>
  );
}
